import { render, staticRenderFns } from "./card-product-cmp.vue?vue&type=template&id=48927378&scoped=true"
import script from "./card-product-cmp.vue?vue&type=script&lang=js"
export * from "./card-product-cmp.vue?vue&type=script&lang=js"
import style0 from "./card-product-cmp.vue?vue&type=style&index=0&id=48927378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48927378",
  null
  
)

export default component.exports